export const PATIENT_MONITORING = {
    masterTableName: "PATIENT_MONITORING",
    tableName: "PATIENT_MONITORING",
    columnName: "ID",
    columnValue: 0,
    withPtId: true,
    title: "patient-monitoring.title",
    rows: [
        { title: "id", value: "ID" },
        { title: "date", value: "CTIME" },
        { title: "note", value: "NOTE" },
    ],
    fields: [
        { field: "note", headerName: "patient-monitoring.note", flex: 1 },
        { field: "ctime", headerName: "patient-monitoring.ctime", flex: 1 },
    ],
    mcpConfig: {
    } as Record<string, { mcpId: number; field: string; scoreField: string }>,
    formData: {
        CUSER: "",
        CTIME: new Date(),
        NOTE: "",
    },
    chartScoreField: "",
    chartTimeField: "CTIME",
};
